import patientIntakeMobile from "../../image/health/aimma-patient/patient-intake-mobile.png";
import aimmaPatientHeroBackdrop from "../../image/health/aimma-patient/aimma-patient-hero-backdrop.png";
import physicianDashboardHero from "../../image/health/aimma-doctor/physician-dashboard-hero.png";
import aimmaBedsidePreview from "../../image/health/aimma-bedside-preview.png";
import aimmaKioskPreview from "../../image/health/aimma-kiosk-preview.png";
import zoeyHospital from "../../image/health/zoey-hospital.png";
import educationSolutionVisual from "../../image/education/education-solution-visual.png";

/** Maps `visual.assetKey` from health content JSON to bundled image assets. */
export const healthProductPreviewAssets: Record<string, string> = {
    "physician-dashboard-hero": physicianDashboardHero,
    "nursing-kiosk-hero": aimmaKioskPreview,
    "ui-kiosk-digital-human": aimmaKioskPreview,
    "ui-bedside-tablet": aimmaBedsidePreview,
    "ui-nursing-coordination-queue": zoeyHospital,
    "medical-sensei-hero": educationSolutionVisual,
    "patient-intake-mobile": patientIntakeMobile,
    "aimma-patient-hero-backdrop": aimmaPatientHeroBackdrop,
};

export function getHealthProductPreviewSrc(
    assetKey: string | undefined
): string | undefined {
    if (!assetKey) return undefined;
    return healthProductPreviewAssets[assetKey];
}
